import { render, staticRenderFns } from "./ESGModuleBarGraph.vue?vue&type=template&id=edb7c7e6&scoped=true"
import script from "./ESGModuleBarGraph.vue?vue&type=script&lang=js"
export * from "./ESGModuleBarGraph.vue?vue&type=script&lang=js"
import style0 from "./ESGModuleBarGraph.vue?vue&type=style&index=0&id=edb7c7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb7c7e6",
  null
  
)

export default component.exports